const loadScript = (src, id) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    if (id) script.id = id
    script.async = true
    script.defer = true
    script.onload = resolve
    script.onerror = reject
    script.src = src
    document.body.append(script)
  })
}

const opt = { id: 'captchaid' }

export const loadGoogleCaptcha = () =>
  loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js', opt.id)

export const connectCaptcha = (id, cb) => {
  const turnstile = window.turnstile
  const el = document.getElementById(opt.id)
  const el2 = document.getElementById(id)
  if (turnstile && el2) {
    turnstile.render(`#${id}`, {
      sitekey: '0x4AAAAAAAin7BjEgPW9ekEn',
      language: localStorage.getItem('language') || 'en-US',
      callback: token => {
        token && cb && cb(token)
        setTimeout(() => {
          el2.innerHTML = ''
        }, 200)
      },
      'error-callback': e => {
        console.log(e, 'error')
      }
    })
  } else {
    if (!el) {
      loadGoogleCaptcha().catch(() => {
        if (el) document.body.removeChild(el)
      })
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/regcpta.js
// module id = biVZ
// module chunks = 10